import styled from 'styled-components';
import { Styling } from '../../../../constants';

export const Asset = styled.div`
  display: flex;
  align-items: center;
  
  margin-top: 20px;
`;

export const AssetThumbnail = styled.img`
  margin-left: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  width: 100px;
`;

export const AssetTitle = styled.div`
  margin-left: ${Styling.DEFAULT_SPACING_DOUBLED}px;
`;
